// Module
var code = "<div class=\"credit-card-form\">\n    <div>\n        <show-cards ng-if=\"AuthService.isUser() || AuthService.isBikeOrganisationOwner() || AuthService.isBikeBusinessSupervisor()\"></show-cards>\n    </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'template/settings/tabs/payment/payment.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;